import { Notifications } from '../views/notifications'
import ModalPanel from '@admin/components/modal_panel'
import PropTypes from 'prop-types'
import React from 'react'

class NotificationsPanel extends React.Component {

  static contextTypes = {
    portal: PropTypes.object
  }

  _handleClose = this._handleClose.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Notifications { ...this.props }/>
      </ModalPanel>
    )
  }

  _getPanel() {
    return {
      title: 't(Notifications)',
      leftItems: [
        { 
          svg: 'x', 
          handler: this._handleClose, 
          tooltip: {
            title: 't(Close Notifications)',
            position: 'bottom left'
          } 
        }
      ]
    }
  }

  _handleClose() {
    this.context.portal.setSidebar(null)
  }

}

export default NotificationsPanel
